export default __webpack_public_path__ + "static/media/self_3_300_225_2.f02c5891.png";